"use client";

import { m } from "framer-motion";
// animation used in the hero section - purple ellipse
export default function GlowEllipse() {
  return (
    <m.div
      initial={{ top: -194, right: 0, rotate: 138.11 }}
      animate={{ top: -87, left: 288, rotate: 138.11 }}
      transition={{
        type: "spring",
        mass: 1,
        stiffness: 40,
        damping: 20,
      }}
      className="absolute w-15 h-100 sm:h-120 tablet:h-140 lg:w-25 xl:w-[135px] xl:h-[837px] rounded-full opacity-40 bg-[#DF27DF] blur-3xl xl:blur-[123px] will-change-[top,left,transform] transform-gpu"
      style={{ position: "absolute" }}
    />
  );
}
